import { render, staticRenderFns } from "./TableTextPreview.vue?vue&type=template&id=27ebd262&scoped=true"
import script from "./TableTextPreview.vue?vue&type=script&lang=js"
export * from "./TableTextPreview.vue?vue&type=script&lang=js"
import style0 from "./TableTextPreview.vue?vue&type=style&index=0&id=27ebd262&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ebd262",
  null
  
)

export default component.exports